<template>
  <multiselect
    :id="id"
    ref="multiSelect"
    :value="value"
    :placeholder="$t('Type to search object', {object: $tc('Languages', 1).toLowerCase()})"
    :label="label"
    :track-by="trackBy"
    :close-on-select="closeOnSelect"
    :multiple="multiple"
    :options-limit="optionsLimit"
    :options="options"
    select-label=""
    deselect-label=""
    selected-label=""
    @input="updateValue"
  />
</template>

<script>
import Multiselect from 'vue-multiselect';
import ApiService from '../../services/ApiService';
import Mixins from '../dropdown/mixins';

export default {
  name: 'AppLanguageDropdown',
  components: {
    Multiselect,
  },
  mixins: [
    Mixins,
  ],
  data() {
    return {
      endpoint: 'languages',
      trackBy: 'id',
      label: 'name',
    };
  },
  mounted() {
    this.find('');
  },
  methods: {
    find(query) {
      const loadingError = new Error(this.$t('Server error'));
      const data = {
        limit: this.optionsLimit,
      };
      data[this.label] = `${query}*`;
      data.order_by = `${this.label},asc`;

      ApiService.request('GET', this.endpoint, data).then((response) => {
        if (response.status === 200) {
          this.options = response.data;
        } else {
          throw loadingError;
        }
      }).catch(() => {
        throw loadingError;
      });
    },
  },
};
</script>
